import { Button, InputAdornment, TextField } from '@mui/material'
import React, {useState, useEffect}  from 'react'
import TitleLink from '../../components/TitleLink'
import { useTranslation } from 'react-i18next';
import Note from './Note';
import { useDispatch, useSelector } from 'react-redux';
import {addNote} from '../../api/APIServices'
import { API_STATUS } from '../../constants';
import { useParams } from 'react-router-dom';

function Notes() {
  const dispatch = useDispatch();
  const {t} = useTranslation('global');
  const [showTextarea, setShowTextarea] = useState(false);
  const[text, setText] = useState("");
  const[userNotes, setUserNotes] = useState([]);
  const params = useParams();
  const userId = params.userId ? params.userId : null;

  const {notes, data:userData, status, noteStatus} = useSelector((state)=> state.user)

  const handleEditFun = ()=>{
    setShowTextarea(prev => !prev)
    setText('');
  }

  const  sortFunction = (a,b) => {  
    var dateA = new Date(a.date).getTime();
    var dateB = new Date(b.date).getTime();
    return dateA < dateB ? 1 : -1;  
  };

  useEffect(()=> {
    const allNote = (notes) ? [...notes] : [];
    allNote.sort(sortFunction);
    setUserNotes(allNote);
  },[noteStatus]);

  const handleAddNote = (userId) => {
    const newNote = {
        note: text, 
        userId: userId, 
    }
   
    dispatch(addNote(newNote));
    setText('');
    setShowTextarea(false)
  };


  return (
    <div style={{margin:'10px 5px', borderRadius:'5px', position: 'relative', border:'1px solid #ccc'}}>
      <TitleLink
      bgColor='aliceblue'
        enableButton={!showTextarea}
        boxTitle={t('notes')}
        buttonTitle={t('add_note')}
        onClick={handleEditFun}
        // show={showTextarea}
      />
        {showTextarea && (<div style={{margin:'0px 10px 20px 10px'}}>
          <TextField
            sx={{width:'100%', whiteSpace: 'pre-wrap', scrollbarWidth:'thin'}}
            id="outlined-multiline-flexible"
            label={t('type_your_note')}
            size="small"
            multiline
            value={text}
            onChange={(e) => setText(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment sx={{position:"absolute", bottom:'20px', right:'5px'}}>
                  <Button variant='outlined' sx={{marginRight:1,textTransform: "none", padding: "0px"}} size='small'  onClick={() => handleAddNote(userId)}> Submit </Button>
                  <Button variant='contained' sx={{marginRight:3,textTransform: "none", padding: "0px"}} size='small' onClick={()=> handleEditFun()}>Cancel</Button>
              </InputAdornment>
              ),
            }}
            rows={4}
          />
          </div>)}
            {noteStatus === API_STATUS.PENDING && <>{t('loading')}..</>}

          {noteStatus === API_STATUS.SUCCESS && userNotes.map((note, index) => (
              <Note 
                key={note.noteId} 
                index={index} 
                note={note} 
                padding = {'0px 10px'} 
                captionTextSize='.7rem' 
                textSize='.8rem' 
              />
          ))}
          
    </div>
  )
}

export default Notes